module.exports = "/fonts/fa-light-300.woff?563925f7d15a0f5ab8d6b764b5b4645e";